import React from "react";
import PteMaxNav from "components/Frontend/PteMax/PteMaxNav";
import PteMaxFooter from "components/Frontend/PteMax/PteMaxFooter";

const TwentyTaskHome = () => (
  <React.Fragment>
    <PteMaxNav />
    <div>20task home</div>
    <PteMaxFooter />
  </React.Fragment>
);

export default TwentyTaskHome;
